export function toTop() {
  const scrollToTopButton = document.querySelector('#scrollToTopButton');
  const ACTIVE_CLASS = 'show';

  if(!scrollToTopButton) {
    return null;
  }

  window.addEventListener('scroll', () => {
    scrollToTopButton.classList[window.scrollY > 400 ? 'add' : 'remove'](ACTIVE_CLASS);
  });

  scrollToTopButton.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}


// WEBPACK FOOTER //
// app/scripts/components/toTop.js